var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2283_4269",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0_2283_4269)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2283_4269)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#CDCDCF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2283_4269",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2283_4269",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2283_4269",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEvElEQVR4nO2d3Y9dUxjGf0YbkbR0Gi4oV9Iqxg0qkajbtmQuGl+JirijjWvRuKA0/UAqETfqhl5Qk0pHBP0XkPAHmPqMUUWrLdqpo0uWvGOOcc7Zn2fttfZ5fsmTTHKSffb7PrO+3r3WPiCEEEIIIYQQopvlwP3Ai8ABYKqkDtg17gOW/ecbRC7GgX3A74CrWb8BLwEr5EU+bge+HYIRi/U1cKtMGcw64HQAM+Z1Sqb0ZwXwXUAz5vUNcJlayv/Z14AZ8/JjiujiKuCPBg05C6ySIwu82qAZzvRKmwy5ErgNmLR1QxHtADoRGNIBni1x/5MWu89Bo1wObAc+BS5EkFDXsC5YLp6y3ATjIuAJ4OcIkuAi1U/AthBmXAK8GUHALhEdBC4dlhljwHsRBOkS04fAxcMwZFcEwblE9XzdZlwP/BlBYC5R+dzdUKchUxEE5VowntSCr/PMRRCQS1zn7PlOZR6IIBjXEvkHZJV5LoJAXEvkKwGVeT2CQFxLtL8OQzSgU5shPpcyhGpJPG71qTtM2600IkMI38V8CVzT41/6WuArtRCCG7JhQP+ySYYQ1IxfrH7XD//ZSY0h/Ltb5ANgD7AVeMjk/95rn1XdvfJFjtF3ZpQN6Vj5wXcjS3Lc9xLrVt4p+UTyXMYux+UlKhitMeRd4LoKMawGDpf4Xj+76sfTJa6XvCEngM3Ux70F+/3zwCM9rvOofTZShsxUbBWDWsvRgvfyGfCy6fMKMSVryIzt1RoWV5cwpQ4laciJIbWMXi3lVxmSbchmwuH3VamFDEjCoYIJ9YuzCeBu00TGYq4X0+qyepvRKdBVrbRF4Q89rjML7LZDP3lYE3DnZFJjyMGc93OXVWCzrvcjsD6yGJMyZENOM4qsjudymlKmUNhqQ07lKIeszNkyerWUrO5rKXBGhiwkzRcDs9hbwXA/pmTxkQxZSJgfoAcx1mcAz6tjOWZf/ti0uixLwuMZybq5hmTdlPEdfre6DLEkbAkw6G7M+I6HZUh+QzYGmMXJkAJd1oS6rPgG9dkK1//eTn4NQoP6okMtWeyuYIg/25LFEY0hCwk7nWNhOG6LvDJT3qwXzWhhWGIWhJVB5gpuVLiTbO4J0DqSKp0Uudn1OVvKsZxmYGX/mGKMwpCOPcXLw7iNKbN9BvBdBd6HtRb4S4b0NuVwwX+WMVuBbzLdmGM2tZj3A5mRXAtxJr9VJxQPBo4tSUNOFui6qp4s9mV/GZIjCUdtq86wWFXyOMFIthDXZcrqIbWMJsxI3hBn+6b8Vp06x4zQ3VSrDHGmadsdUpa1gWdTrTfE2TplyvZf+VJHFkttBX4o4DpjpAxxXTpjz8BfsCd9W0zbrGp7JNCmBRlC80mVITSfSBlC88mTITSfMBkSQZJcaobsjyAQ1xK9VochOyIIxLVEz6R4ysi1WLU8WlhmL6tvOhiXuGp7xR/2NoSmA3KJ621qZE3Jg/IS/+Tg/DAeJexUgin7D+YnRrUzFvjEqmuJpkucDC70Mv43IgjSJaK3hvky/m62ljzvNyo6DjxGYPwbr58EPtEPujD/gy4fW05qm96W5Qr7PcAyP3mUuiaBWywHQgghhBBCCCGEEEIIIYQQgsH8DWBBWLYimA4wAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.d52e697d3a598f6371b0daa8f02ba560.svg";
export { ForwardRef as ReactComponent };